<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div class="row items-center">
        <div class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Cadastrar Usuário
        </div>
      </div>
    </div>
    <div class="q-mt-lg q-ml-md">
      <q-form ref="myForm" @submit="cadastrarFuncionario">
        <div class="row col-12 q-col-gutter-sm text-brand-1 text-weight-bold">
          <div class="col-4">
            <div class="q-ml-sm">Unidade</div>
            <UnidadeSelect :validacao="true" v-model="dadosUsuario.unidade" />
          </div>
          <div class="col-4">
            <div class="q-ml-sm">Centro de Custo</div>
            <SelectCentroCustos
              :validacao="true"
              v-model="dadosUsuario.centroCusto"
            />
          </div>
        </div>
        <div
          class="row col-12 q-mt-sm q-col-gutter-sm text-brand-1 text-weight-bold"
        >
          <div class="col-8">
            <div class="q-ml-sm">Nome</div>
            <q-input
              v-model="dadosUsuario.nome"
              dense
              outlined
              hide-bottom-space
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            />
          </div>
        </div>
        <div
          class="row col-12 q-mt-sm q-col-gutter-sm text-brand-1 text-weight-bold"
        >
          <div class="col-4">
            <div class="q-ml-sm">Matrícula</div>
            <q-input
              v-model="dadosUsuario.matricula"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
              dense
              hide-bottom-space
              outlined
            />
          </div>
          <div class="col-4">
            <div class="q-ml-sm">E-mail</div>
            <q-input
              v-model="dadosUsuario.email"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
              dense
              type="email"
              hide-bottom-space
              outlined
            />
          </div>
        </div>
        <div class="row col-12 q-mt-lg">
          <q-btn
            type="submit"
            style="color: white; background-color: #304f78; border-radius: 8px"
            label="Criar Usuário"
            icon="add"
            no-caps
          />
        </div>
      </q-form>
    </div>
  </q-page>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
// import { useRouter } from "vue-router";

import UnidadeSelect from "../../../components/unidade/UnidadeSelect.vue";
import SelectCentroCustos from "../../legado/compras/components/SelectCentroCustos.vue";

const store = useStore();
const quasar = useQuasar();
// const router = useRouter();

const dadosUsuario = ref({
  nome: "",
  unidade: "",
  centroCusto: "",
  email: "",
  matricula: "",
});

const cadastrarFuncionario = async () => {
  try {
    await store.dispatch("usuarioNovo/cadastrarFuncionario", {
      sap: dadosUsuario.value.matricula,
      name: dadosUsuario.value.nome,
      email: dadosUsuario.value.email,
      vendor_id: dadosUsuario.value.unidade?.id,
      cost_center_id: dadosUsuario.value.centroCusto?.id,
    });
    quasar.notify({
      message: "Usuário criado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    // router.push({name: })
  } catch (error) {
    console.log(error);
  }
};
</script>
